import { ReactNode } from 'react';
import { Stack } from '../../../../../design-system/stack/stack';

type TwoLineCellProps = {
  primary: ReactNode;
  secondary?: ReactNode;
  showSecondary: boolean;
  align?: 'start' | 'end';
};

export const TwoLineCell = ({ primary, secondary, showSecondary, align = 'start' }: TwoLineCellProps) => {
  if (!showSecondary) {
    return <>{primary}</>;
  }

  return (
    <Stack data-testid="two-line-cell" space={2} align={align}>
      {primary}

      {secondary}
    </Stack>
  );
};
